// src/data/TermsAndConditions.js
// Terms and Conditions Content - Separated from OrderForm component

export const TERMS_AND_CONDITIONS = `CONTEXT NETWORKS, INC.

TERMS AND CONDITIONS FOR DIGITAL ADVERTISING MEDIA PURCHASES

These Terms and Conditions for Digital Advertising Media Purchases ("Terms") govern the relationship between Context Networks, Inc. ("Context Networks" or "Buyer") and media companies providing advertising inventory. By submitting an Insertion Order or providing advertising inventory to Context Networks, Media Company agrees to be bound by these Terms.

DEFINITIONS

"Ad" means any advertisement provided by Context Networks on behalf of an Advertiser.

"Advertiser" means the advertiser for which Context Networks is purchasing media.

"Advertising Materials" means artwork, copy, or active URLs for Ads.

"Affiliate" means, as to an entity, any other entity directly or indirectly controlling, controlled by, or under common control with, such entity.

"CPA Deliverables" means Deliverables sold on a cost per acquisition basis.

"CPC Deliverables" means Deliverables sold on a cost per click basis.

"CPL Deliverables" means Deliverables sold on a cost per lead basis.

"CPM Deliverables" means Deliverables sold on a cost per thousand impression basis.

"Deliverable" or "Deliverables" means the inventory delivered by Media Company (e.g., impressions, clicks, or other desired actions).

"IO" or "Insertion Order" means a mutually agreed insertion order that incorporates these Terms, under which Media Company will deliver Ads on Sites for the benefit of Context Networks and/or Advertiser.

"Media Company" means the publisher or media company providing advertising inventory to Context Networks.

"Policies" means advertising criteria or specifications made available by Media Company, including content limitations, technical specifications, privacy policies, and editorial guidelines.

"Sites" means websites, mobile applications, digital out-of-home displays, private marketplace displays, or other digital properties owned, operated, or controlled by Media Company where Ads will be displayed.

"Terms" means these Terms and Conditions for Digital Advertising Media Purchases.

"Third Party Ad Server" means a third party service that will serve and/or track Ads.

I. INSERTION ORDERS AND INVENTORY ACCEPTANCE

a. IO Details
Each IO will specify: (i) the type(s) and amount(s) of Deliverables, (ii) the price(s) for such Deliverables, (iii) the maximum amount to be spent, (iv) the start and end dates of the campaign, and (v) any Third Party Ad Server information.

b. Acceptance
Media Company will notify Context Networks within two (2) business days if specified inventory is not available. Acceptance occurs upon: (i) written approval by both parties, or (ii) display of the first Ad impression, whichever is earlier.

c. Modifications
Revisions to accepted IOs must be made in writing and acknowledged by both parties.

II. AD PLACEMENT AND DELIVERY

a. Compliance with IO
Media Company will comply with the IO specifications and create a reasonably balanced delivery schedule. Media Company will provide Ads to digital properties when accessed by users, subject to the terms specified in the IO.

b. Site Changes
Media Company will provide Context Networks at least 10 business days' notice of material changes to digital properties that would materially affect Ad placement or target audience. Context Networks may cancel affected placements without penalty if adequate notice is not provided.

c. Technical Specifications
Media Company will provide final technical specifications within two (2) business days of IO acceptance. Changes to specifications after this period will allow Context Networks to suspend delivery, request revisions, or cancel affected placements.

d. Editorial Guidelines
Media Company acknowledges that Advertisers may require their Ads not be placed adjacent to inappropriate content (pornography, violence, obscene language, etc.). Media Company will use commercially reasonable efforts to comply with editorial adjacency guidelines specified in the IO.

III. PAYMENT AND BILLING

a. Invoicing
Initial invoices will be sent upon completion of first month's delivery or within 30 days of IO completion, whichever is earlier. All invoices must be sent within 90 days of delivery completion. Invoices will include IO number, Advertiser name, campaign details, and Context Networks' specified billing information.

b. Payment Terms
Context Networks will make payment 30 days from receipt of invoice, unless otherwise specified in the IO. Media Company must provide proof of performance upon request.

c. Payment Responsibility
Unless otherwise specified, Context Networks' liability for payments is limited to proceeds actually received from Advertisers. Media Company understands that Advertisers are Context Networks' disclosed principals, and Context Networks acts as agent.

IV. REPORTING AND PERFORMANCE

a. Campaign Confirmation
Media Company will confirm campaign initiation within two (2) business days of the start date.

b. Reporting Requirements
If Media Company is serving the campaign, reports will be provided at least weekly, broken down by day and including creative execution, placement, impressions, clicks, spend, and other variables specified in the IO.

c. Reporting Accuracy
Once provided, Context Networks may reasonably rely on reports, subject to invoice reconciliation. Failure to provide accurate reports may result in makegood requirements.

V. CANCELLATION AND TERMINATION

a. Cancellation Without Cause
Unless designated as non-cancelable, Context Networks may cancel:
- Guaranteed Deliverables with 14 days' notice
- Non-guaranteed Deliverables with 7 days' notice
- Fixed-placement Deliverables with 30 days' notice

b. Termination for Cause
Either party may terminate for material breach not cured within 10 days of written notice. Media Company may terminate if Context Networks violates the same Policy three times after notice.

VI. MAKEGOODS AND UNDER-DELIVERY

a. Under-delivery Notification
Media Company will monitor delivery and notify Context Networks at least 14 days before IO end date if under-delivery is likely.

b. Makegood Procedures
If actual delivery falls below guaranteed levels, parties will agree on makegood conditions. If no makegood can be agreed upon, Context Networks may execute a credit equal to the under-delivered portion's value.

VII. BONUS IMPRESSIONS

a. With Third Party Ad Server
Media Company will not bonus more than 10% above specified Deliverables without Context Networks' consent when Third Party Ad Servers are used.

b. Without Third Party Ad Server
When Context Networks does not use a Third Party Ad Server, Media Company may provide bonus inventory as specified in the IO, with no additional charges above guaranteed levels.

VIII. THIRD PARTY AD SERVING (If Applicable)

a. Tracking and Measurement
If both parties track delivery, the controlling measurement will be determined by IAB/AAAA compliance standards, with preference given to Third Party Ad Servers meeting specified technical requirements.

b. Discrepancy Resolution
If measurement differences exceed 10%, parties will facilitate reconciliation. If unresolved, Context Networks may consider discrepancies as under-delivery per Section VI.

IX. ADVERTISING MATERIALS

a. Submission and Compliance
Context Networks will submit Advertising Materials in accordance with Media Company's Policies. Media Company may reject materials that don't comply with Policies or applicable law.

b. Late Creative
If materials are not received by start date, Media Company will begin charging on a pro rata basis. Media Company is not required to guarantee full delivery if materials are late.

c. No Modification
Media Company will not modify submitted Ads without Context Networks' approval and will implement all materials according to IO specifications.

X. CONFIDENTIALITY AND DATA

a. Confidential Information
Both parties will protect confidential information with reasonable care and use it only for IO performance. IO details, pricing information, and performance data are considered confidential.

b. Data Ownership
- User Volunteered Data collected specifically for Advertiser belongs to Advertiser
- Performance Data may be used by Context Networks for internal analysis and reporting
- Site Data remains the property of Media Company

c. Privacy Compliance
Both parties will maintain privacy policies and comply with applicable data protection laws.

XI. INDEMNIFICATION

a. By Media Company
Media Company will indemnify Context Networks and Advertisers against claims arising from: (i) Media Company's breach of representations or delivery obligations, (ii) Media Company-provided content that violates law or third party rights.

b. By Context Networks/Advertiser
Context Networks and Advertisers will indemnify Media Company against claims arising from: (i) breach of these Terms, (ii) violation of Policies after proper notice, (iii) content of Ads or Advertising Materials.

XII. LIMITATION OF LIABILITY

Except for indemnification obligations, breach of confidentiality, or intentional misconduct, neither party will be liable for consequential, indirect, incidental, punitive, or special damages, including loss of profits or business interruption.

XIII. FORCE MAJEURE

Neither party will be liable for delays caused by conditions beyond reasonable control, including technical failures, natural disasters, or network outages. If Force Majeure continues for five (5) business days, either party may cancel the remainder of the IO.

XIV. GENERAL PROVISIONS

a. Entire Agreement
Each IO (including these Terms) constitutes the entire agreement between the parties for that campaign and supersedes all prior agreements regarding the subject matter.

b. Governing Law
These Terms will be governed by the laws of Delaware. Any disputes will be resolved in the state or federal courts of Delaware, and parties consent to such jurisdiction.

c. Amendment
These Terms may only be modified in writing signed by both parties. If any provision is unenforceable, the remaining provisions remain in effect.

d. Assignment
Neither party may assign rights or obligations without the other party's written consent, except Context Networks may assign to Affiliates or in connection with a merger or sale.

e. Notices
Notices will be sent to addresses specified in the IO and deemed delivered three days after mailing, one day if by overnight courier, or immediately if electronic with confirmation.

f. Survival
Sections relating to payment, confidentiality, indemnification, limitation of liability, and general provisions survive termination.

Effective Date: January 1, 2020
Version: 1.0`;